
import ExampleBtn from '../components/ExampleBtn';

export default function ExampleNavbtns({theme, setPage}) {
  return (
    <div className="exampleNavbtnsDiv">
        <ExampleBtn width={"20%"} height={"100%"} bg_color={theme.primary_color} color={theme.accent_color} text={"עמוד הבית"} action={()=>{setPage(0)}}/>
        <ExampleBtn width={"20%"} height={"100%"} bg_color={theme.primary_color} color={theme.accent_color} text={"המוצרים שלנו"} action={()=>{setPage(1)}}/>
        <ExampleBtn width={"20%"} height={"100%"} bg_color={theme.primary_color} color={theme.accent_color} text={"סניפים"} action={()=>{setPage(2)}}/>
        <ExampleBtn width={"20%"} height={"100%"} bg_color={theme.primary_color} color={theme.accent_color} text={"דרושים"} action={()=>{setPage(3)}}/>
        <ExampleBtn width={"20%"} height={"100%"} bg_color={theme.primary_color} color={theme.accent_color} text={"אודות"} action={()=>{setPage(4)}}/>
    </div>
  )
}
